import { HttpClient, HttpParams } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AmadeusModel } from '../../models/AmadeusModel';
import { MethodModel } from '../../models/MethodModel';
import Swal from 'sweetalert2'
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-test-services',
  templateUrl: './test-services.component.html',
  styleUrls: ["../../../assets/css/style.scss"]
})
export class TestServicesComponent implements OnInit {
  public TestForm: FormGroup;

  public FormAmadeus: FormGroup;
  public ListMethod: MethodModel[];
  public ItemMethod: MethodModel = new MethodModel();
  public xmlDocString: string;
  public nameMethod : String;
  public xmlDocStringBool: boolean;
  public myReaponse :String =""
  constructor(private http: HttpClient,
    private router: Router,private SpinnerService: NgxSpinnerService) { }

  ngOnInit() {
    //this.GetMethod();
    this.loadForm();
    this.GetAllMethod();
  }

  public Method: MethodModel[];


  private GetAllMethod() {    
    this.SpinnerService.show();
    let UserInf: any;
    UserInf = localStorage.getItem("ResponseData");
    let body = new HttpParams();
    body = body.set('data', UserInf);

    this.http.post<MethodModel[]>(window.location.origin + '/api/Service/GetMethod/', body)
      .subscribe(data => {
        this.ListMethod = data;
        console.log(this.ListMethod)        
      });

    this.SpinnerService.hide();
  }

  loadForm(): void {
    this.TestForm = new FormGroup({
      fc_method: new FormControl({ }),
      fc_oid: new FormControl(),
      fc_iata: new FormControl(),
      fc_request: new FormControl(),
      fc_response: new FormControl(),
    });

    this.FormAmadeus = new FormGroup({
      fc_method: new FormControl('', Validators.required),
      fc_oid: new FormControl('', Validators.required),
      fc_iata: new FormControl('', Validators.required ),
      fc_request: new FormControl('', [Validators.required,Validators.minLength(10)]),
      fc_response : new FormControl()
    });
  }
  

  onChangeMethod(value: string) {
    this.myReaponse =   "";
    this.FormAmadeus.controls['fc_response'].setValue("");
    var id: number = +value;
    this.ItemMethod = this.ListMethod.find(element => element.Id == id);
    var request: string = this.ItemMethod.Request.toString();
    this.FormAmadeus.controls['fc_oid'].setValue('00000000');
    this.FormAmadeus.controls['fc_iata'].setValue('BOGAV07SB');    
    this.FormAmadeus.controls['fc_request'].setValue(request);
    //TestForm.
  
  }
 
     
  get FormAmadeusControl() {
    return this.FormAmadeus.controls;
  }
  async onFormSubmit() {
    //debugger;
    console.log(this.FormAmadeus.invalid)
    if (this.FormAmadeus.invalid) {
      this.FormAmadeus.markAllAsTouched;
      return;
    }

    let rootObject = new AmadeusModel();
    rootObject = this.FormAmadeus.value;
    var value = this.FormAmadeus.get('fc_method').value;
    var id: number = +value;
    this.ItemMethod = this.ListMethod.find(element => element.Id == id); // se extrae el nombre del metodo por un filtrado del objeto
    rootObject.fc_method  =  this.ItemMethod["Metodo1"]
    this.nameMethod = rootObject.fc_method;
    const body = {  ObjectRequest: JSON.stringify(rootObject)  }
    this.SpinnerService.show();
    var url =this.getRequestUrl("Amadeus", "ExecuteMethod");
    let response = await this.http.post<MethodModel>(url, body)
      .toPromise()
      .catch(async ex => {
        var errorType = ex.error.errorType;
        var error = errorType === 'Application' ? ex.error.message : '';
        if (error) {
         console.log(error)
        }
      });
      this.SpinnerService.hide();
    this.myReaponse =   response["fc_response"];
    this.FormAmadeus.controls['fc_response'].setValue( response["fc_response"]);
    this.xmlDocStringBool = true;

  }


  private getRequestUrl(controller, action) {
    return `${window.location.origin}/api/${controller}/${action}`;
  }
  /*
   *ejecuta el servicio de pruebas
   */
  // private serv_test(item: MethodModel) {
  //   debugger;
  //   this.SpinnerService.show();
  //   let UserInf: any;
  //   UserInf = localStorage.getItem("ResponseData");
  //   let body = new HttpParams();
  //   body = body.set('data', item.Request);

  //   this.http.post<MethodModel[]>(window.location.origin + '/api/Service/TestService/', body)
  //     .subscribe(data => {
  //       this.ListMethod = data;
  //       console.log(this.ListMethod)        
  //     });

  //   this.SpinnerService.hide();
  // }

  public Download(xmlDocString)
  {
    debugger;
      var filename = this.nameMethod+".xml";
      var pom = document.createElement('a');
      var bb = new Blob([xmlDocString], {type: 'text/plain'});

      pom.setAttribute('href', window.URL.createObjectURL(bb));
      pom.setAttribute('download', filename);

      pom.dataset.downloadurl = ['text/plain', pom.download, pom.href].join(':');
      pom.draggable = true; 
      pom.classList.add('dragout');

      pom.click();
  }
}
